<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewInquiry"
        :searchFilters="searchFilters"
        :dropdownOptions="dropdownOptions"
        @handleDynamicOption="handleDynamicOption"
        @searchPage="searchInquiries"
        @resetFilters="resetFilters"
        @removeItem="removeInquiry"
        @removeSelectedItems="removeInquirys"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="inquiryList"
        :actions="actions"
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveInquiry" @handleReset="handleReset"
        />
    </MovableModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'Customer_Inquiries',
    components:{
        PageComponent,MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const title = ref('Inquiry Details');
        const addButtonLabel = ref('New Inquiry');
        const addingRight = ref('Adding Customer Inquiries');
        const removingRight = ref('Deleting Customer Inquiries');
        const rightsModule = ref('CRM');
        const idField = 'inquiry_id';
        const agentID = ref('');
        const agentComponentKey = ref(0);
        const agentArray = computed(() => store.state.Sales_Reps.agentArr);
        const selectedIds = ref([]);
        const depModalVisible = ref(false);
        const inquiryList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const selectedValue = ref(50);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Customer_Inquiries.isEditing)
        const selectedInquiry = computed(()=> store.state.Customer_Inquiries.selectedInquiry);
        const selectedRep = computed(()=> store.state.Customer_Inquiries.selectedRep);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "created_at"},
            {label: "Client Name", key: "customer_name"},
            {label: "Email", key: "customer_email"},
            {label: "Subject", key: "subject"},
            {label: "Message", key: "message", maxWidth:"700px"},
            {label: "Status", key: "status", textColor: "statusColor"},
            {label: "Assigned To", key: "assigned_to"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Inquiry', rightName: 'Editing Customer Inquiries'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Inquiry', rightName: 'Deleting Customer Inquiries'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const customer_name = ref('');
        const status_search = ref('');
        const subject_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Search Name...", value: customer_name, width:48},
            {type:'text', placeholder:"Search Subject...", value: subject_search, width:48},
            {
                type:'dropdown', placeholder:"Status..", value: status_search, width:32,
                options: [{text:'Open',value:'Open'},{text:'In Progress',value:'In Progress'},{text:'Resolved',value:'Resolved'},{text:'Closed',value:'Closed'}]
            },
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchSalesAgents = async() =>{
            await store.dispatch('Sales_Reps/fetchSalesAgents', {company:companyID.value})
        };
        const handleSelectedAgent = async(option) =>{
            await store.dispatch('Sales_Reps/handleSelectedAgent', option)
            agentID.value = store.state.Sales_Reps.agentID;
            if(selectedInquiry.value && selectedRep.value){
                selectedInquiry.value.assigned_to.sales_rep_id = agentID.value;
            }
        }
        const clearSelectedAgent = async() =>{
            await store.dispatch('Sales_Reps/updateState', {agentID: ''});
            agentID.value = store.state.Sales_Reps.agentID;
        }
        const agentValue = computed(() => {
           return (selectedInquiry.value && selectedInquiry.value.assigned_to && !agentID.value) ? selectedInquiry.value.assigned_to.sales_rep_id : agentID.value;
        });
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                { type: 'text', name: 'customer_name',label: "Customer Name", value: selectedInquiry.value?.customer_name || '', required: true },
                { type: 'text', name: 'customer_email',label: "Customer Email", value: selectedInquiry.value?.customer_email || '', required: true },
                { type: 'text', name: 'subject',label: "Subject", value: selectedInquiry.value?.subject || '', required: true },
                { type: 'dropdown', name: 'status',label: "Status", value: selectedInquiry.value?.status || 'Open', required: true , options: [{text:'Open',value:'Open'},{text:'In Progress',value:'In Progress'},{text:'Resolved',value:'Resolved'},{text:'Closed',value:'Closed'}]},
                {  
                    type:'search-dropdown', label:"Sales Rep", value: agentValue.value, componentKey: agentComponentKey,
                    selectOptions: agentArray, optionSelected: handleSelectedAgent, required: false,
                    searchPlaceholder: 'Select Rep...', dropdownWidth: '500px', updateValue: selectedRep.value,
                    clearSearch: clearSelectedAgent
                },
                { type: 'text-area', name: 'message',label: "Message", value: selectedInquiry.value?.message || '', textarea_rows: '3', textarea_cols: '56', required: true },
            ];
        };
        watch([selectedInquiry,selectedRep], () => {
            if(selectedInquiry.value && selectedRep.value){
                agentComponentKey.value += 1;
                updateFormFields();
            }else if(selectedInquiry.value){
                updateFormFields();
            }
         }, { immediate: true });
        const addNewInquiry = () =>{
            updateFormFields();
            depModalVisible.value = true;
            handleReset();
            store.dispatch("Customer_Inquiries/updateState",{isEditing:false})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const inquiryID = row[idField];
                let formData = {
                    company: companyID.value,
                    inquiry: inquiryID
                }
                await store.dispatch('Customer_Inquiries/fetchCustomerInquiry',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                })
                
            }else if(action == 'delete'){
                const sourceID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    inquiry: sourceID
                }
                await store.dispatch('Customer_Inquiries/deleteCustomerInquiry',formData).
                then(()=>{
                    searchInquiries();
                })
            }
        } 
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            formFields.value[3].value = 'Open';
            agentID.value = '';
            agentComponentKey.value += 1;

        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createCustomerInquiry = async() =>{
            showModalLoader();
            let formData = {
                customer_name: formFields.value[0].value,
                customer_email: formFields.value[1].value,
                subject: formFields.value[2].value,
                status: formFields.value[3].value,
                message: formFields.value[5].value,
                assigned_to: agentID.value,
                assigned_to_id: agentID.value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Customer_Inquiries/createCustomerInquiry', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Customer Inquiry created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Customer Inquiry.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Customer Inquiry: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchInquiries();
                }
            }

        }
        const updateCustomerInquiry = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                customer_name: formFields.value[0].value,
                customer_email: formFields.value[1].value,
                subject: formFields.value[2].value,
                status: formFields.value[3].value,
                message: formFields.value[5].value,
                assigned_to: agentValue.value,
                assigned_to_id: agentValue.value,
                company: companyID.value,
                inquiry: selectedInquiry.value.inquiry_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else{
                try {
                    const response = await store.dispatch('Customer_Inquiries/updateCustomerInquiry', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Customer Inquiry updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Customer Inquiry.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Customer Inquiry: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchInquiries();
                }
            }
        }
        const saveInquiry = () =>{
            if(isEditing.value == true){
                updateCustomerInquiry();
            }else{
                createCustomerInquiry();
            }
        }
        const removeInquiry = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    inquiry: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Customer_Inquiries/deleteCustomerInquiry',formData)
                    if(response && response.status == 200){
                        toast.success("Inquiry Removed Succesfully");
                        searchInquiries();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Customer Inquiry: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Inquiry") 
            }else{
                toast.error("Please Select An Inquiry To Remove")
            }
        }
        const removeInquirys = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    inquiry: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Customer_Inquiries/deleteCustomerInquiry',formData)
                    if(response && response.status == 200){
                        toast.success("Inquiry(s) Removed Succesfully");
                        searchInquiries();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Inquiry(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select An Inquiry To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchInquiries = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                customer_name: customer_name.value,
                subject: subject_search.value,
                status: status_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/customer-inquiries-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                inquiryList.value = response.data.results;
                store.commit('Customer_Inquiries/LIST_INQUIRIES', inquiryList.value)
                depResults.value = response.data;
                depArrLen.value = inquiryList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchInquiries();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchInquiries();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchInquiries();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchInquiries();
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchInquiries(selectedValue.value);
        };
        const dropdownOptions = ref([
            
        ]);
        const handleDynamicOption = async(option) =>{
        
        };
        const resetFilters = () =>{
            status_search.value = '';
            subject_search.value = '';
            customer_name.value = '';
            currentPage.value = 1;
            searchInquiries();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        onMounted(()=>{
            searchInquiries();
            fetchSalesAgents();
        })
        return{
            title,idField, searchInquiries, addButtonLabel, searchFilters, resetFilters, tableColumns, inquiryList,handleSelectionChange,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewInquiry,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveInquiry,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeInquiry, removeInquirys,
            addingRight,removingRight,rightsModule, closeModal,selectedValue, selectSearchQuantity,dropdownOptions, handleDynamicOption
        }
    }
}
</script>